/** One titled part of the builder form — TentpoleCalendar/EntryEditor's Section, with an optional note and action. */

import React from 'react';

interface Props {
  /** DOM id of the section (headings link to it). */
  id: string;
  title: string;
  /** One line under the title. */
  note?: React.ReactNode;
  /** Right of the title, e.g. "+ Add audience". */
  action?: React.ReactNode;
  first?: boolean;
  /** Dim the section while its numbers are being re-priced. */
  busy?: boolean;
  children: React.ReactNode;
}

const FormSection: React.FC<Props> = ({ id, title, note, action, first = false, busy = false, children }) => (
  <section id={id} aria-labelledby={`${id}-title`} aria-busy={busy || undefined} style={first ? styles.section : { ...styles.section, ...styles.rule }}>
    <div style={styles.head}>
      <div style={{ minWidth: 0 }}>
        <h3 id={`${id}-title`} style={styles.title}>
          {title}
        </h3>
        {note && <div style={styles.note}>{note}</div>}
      </div>
      {action}
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, opacity: busy ? 0.6 : 1, transition: 'opacity var(--dur-fast) var(--ease-standard)' }}>{children}</div>
  </section>
);

const styles: Record<string, React.CSSProperties> = {
  section: { display: 'flex', flexDirection: 'column', gap: 14 },
  rule: { paddingTop: 22, borderTop: '1px solid var(--border-subtle)' },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' },
  // Outranks the uppercase field labels, so the sections read at a glance.
  title: { margin: 0, fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 700, color: 'var(--fg-1)' },
  note: { fontSize: 12.5, color: 'var(--fg-4)', marginTop: 3 },
};

export default FormSection;
